module.exports = __webpack_public_path__ + "expedia-logo.png?33666caed05cf699ab7c8cb42419a3fc";